// Models
export const SET_MODELS = 'SET_MODELS';



// WEBPACK FOOTER //
// ./src/store/reducers/models/actionTypes.js